(function (conf) {
    var form = document.forms['contact-form'],
        agreeAll = document.getElementById( 'agree-all' );

    if (!form) {
        return;
    }

    form.addEventListener( 'change', function ( e ) {
        if ( 0 < e.srcElement.value.length ) {
            form.querySelectorAll( '.form-row--tos' ).forEach( function ( row ) {
                row.style.height = row.scrollHeight + 'px';
            });
        }
    });

    form.addEventListener('submit', function (e) {
        var request = new XMLHttpRequest(),
            data = new FormData(form);

        e.preventDefault();

        request.addEventListener('load', function () {
            var height = form.getBoundingClientRect().height;
            form.innerHTML = 'Dziękujemy za wiadomość. Odpowiemy wkrótce.';
            form.style.height = height + 'px';
        });
        request.open('POST', conf.ajaxUrl);
        request.send(data);
    });

    if ( agreeAll ) {
        agreeAll.addEventListener( 'change', function ( e ) {
            var fields = this.dataset.fields.split( ',' ),
                form = this.closest( 'form' ),
                checked = this.checked;

            fields.forEach( function ( elem ) {
                form[ elem ].checked = checked;
            });
        });
    }
}(window.HabzaContactConfig));

// Prevents scroll-zoom on virtual tour
(function () {
    var tour = document.querySelector( '.virtual-tour' ),
        embed = tour.querySelector( 'iframe' ),
        overlay = tour.querySelector( '.scroll-overlay' );

    if ( ! tour ) {
        return;
    }

    function preventScrollZoom () {
        overlay.style.display = 'block';
    }

    function allowScrollZoom () {
        overlay.style.display = 'none';
    }

    function mouseOutCb () {
        preventScrollZoom();
        embed.removeEventListener( 'mouseout', mouseOutCb );
    }

    overlay.addEventListener( 'click', function () {
        allowScrollZoom();

        embed.addEventListener( 'mouseout', mouseOutCb );
    });
}());